
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="WetGripClassSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#545456" d="M16.045 18h-.915a.644.644 0 01-.638-.649.645.645 0 01.638-.648h.876a3.277 3.277 0 001.659-.69 3.26 3.26 0 001.056-2.462 3.497 3.497 0 00-1.627-3.29 4.654 4.654 0 00-1.742-.638.642.642 0 01-.568-.557 3.957 3.957 0 00-.554-1.41A2.9 2.9 0 0011.705 6.3h-.153a2.9 2.9 0 00-2.193.825 4.762 4.762 0 00-1.006 3.186.645.645 0 01-.561.683 3.088 3.088 0 00-2.5 2.825 2.863 2.863 0 00.783 2.417c.23.212.503.372.8.47h3.665a.646.646 0 01.592.894.648.648 0 01-.346.352.642.642 0 01-.246.05H6.793a.646.646 0 01-.13-.013A3.341 3.341 0 015.22 17.2a4.105 4.105 0 01-1.2-3.49v-.041a4.465 4.465 0 011.97-3.317c.339-.22.706-.395 1.092-.516a5.75 5.75 0 011.361-3.614 4.114 4.114 0 013.106-1.22h.186a4.154 4.154 0 013.6 1.989c.274.442.482.922.617 1.424a5.956 5.956 0 011.818.741 4.764 4.764 0 012.233 4.435v.013A4.269 4.269 0 0116.045 18z"/><path fill="#545456" d="M12.951 17.999a.65.65 0 100-1.3.65.65 0 000 1.3zM17.65 20.999a.65.65 0 100-1.3.65.65 0 000 1.3zM14.65 20.999a.65.65 0 100-1.3.65.65 0 000 1.3zM11.65 20.999a.65.65 0 100-1.3.65.65 0 000 1.3z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'WetGripClassSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
